import { Component, Input, OnInit } from '@angular/core';
import { ToastService } from 'src/app/services/toast/toast.service';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ApiService } from 'src/app/_services/api.service';
import { ReservationDetailsDialogComponent } from '../reservation-details-dialog/reservation-details-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { Operations } from "../../../_models/Reservation/ReservationStatus";

@Component({
  selector: 'app-reservation-item',
  templateUrl: './reservation-item.component.html',
  styleUrls: ['./reservation-item.component.scss']
})
export class ReservationItemComponent implements OnInit {

  // @Input() reservation?: ReservationModel;
  @Input() reservation?: any;
  loading:boolean = false;

  constructor(
    private toastMessagesService: ToastService,
    private apiService: ApiService,
    private dialog: MatDialog,
    private translate: TranslateService,
    ) { }

  ngOnInit() {
  }

  confirmReservation(reservationId: string){
    this.loading=true;
    this.apiService.confirmReservation(reservationId).subscribe(()=>{
      this.reloadReservations(this.reservation?.eventId);
      this.loading=false;
    })
  }

  refuseReservation(reservationId: string){
    this.loading=true;
    this.apiService.refuseReservation(reservationId).subscribe(()=>{
      this.reloadReservations(this.reservation?.eventId)
      this.loading=false;
    })
  }

  reloadReservations(eventId: string): void {
    this.apiService.getReservations(eventId, Operations.WaitingApproval).subscribe(_ =>
      this.apiService.getReservations(eventId, Operations.WaitingApprovalChanged, true).subscribe()
    );
  }

  openMore(reservationId: string){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    let DialogTitle = this.translate.instant('RESERVATIONS.PENDING_RESERVATION');
    dialogConfig.data = {
      dialogTitle: DialogTitle,
      reservationId: reservationId,
    };

    dialogConfig.width='450px';

    const dialogRef = this.dialog.open(ReservationDetailsDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
    });
  }

  openConfirmedDetails(reservationId: string){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    let DialogTitle = this.translate.instant('RESERVATIONS.APPROVED_RESERVATION');
    dialogConfig.data = {
      dialogTitle: DialogTitle,
      reservationId: reservationId,
    };

    dialogConfig.width='450px';

    const dialogRef = this.dialog.open(ReservationDetailsDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
    });
  }

  openRefusedDetails(reservationId: string){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    let DialogTitle = this.translate.instant('RESERVATIONS.REFUSED_RESERVATION');
    dialogConfig.data = {
      dialogTitle: DialogTitle,
      reservationId: reservationId,
    };

    dialogConfig.width='450px';

    const dialogRef = this.dialog.open(ReservationDetailsDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
    });
  }

  openCanceledDetails(reservationId: string){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    let DialogTitle = this.translate.instant('RESERVATIONS.CANCELED_RESERVATION');
    dialogConfig.data = {
      dialogTitle: DialogTitle,
      reservationId: reservationId,
    };

    dialogConfig.width='450px';

    const dialogRef = this.dialog.open(ReservationDetailsDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
    });
  }

  onSuccess(): void {
    this.toastMessagesService.nextToastMessage({
      severity:'success',
      summary: 'Success',
      detail: 'Event has been successfully published'
    });
  }

  onError(): void {
    this.toastMessagesService.nextToastMessage({
      severity:'error',
      summary: 'Error',
      detail: 'There are some problems'
    });
  }

}
